import { gql } from '@apollo/client'

export default gql(`
    mutation updateOptaSyncState( 
        $id: ID! $title: String  $lastRunTime: AWSDateTime $frequency: Int $opId: String $isActive: Boolean $isRunning: Boolean $isError: Boolean
        $isNonOpta: Boolean $baseUrl: String $source: String $enableFasterSync: Boolean
    ) {
        updateOptaSyncState(
            input: {
                id: $id
                title: $title
                lastRunTime: $lastRunTime
                frequency: $frequency
                isActive: $isActive
                isError: $isError
                isRunning: $isRunning
                opId: $opId
                isNonOpta: $isNonOpta
                baseUrl: $baseUrl
                source: $source
                enableFasterSync: $enableFasterSync
            }
        ) {
            id
            title
            lastRunTime
            frequency
            isActive
            isRunning
            isError
            opId
            isNonOpta
            baseUrl
            source
            enableFasterSync
        }
    }`
)
